import type { TimeEntryDto } from './time-tracking.dto.js';

export const timeEntryAdjustmentStatusValues = ['pending', 'approved', 'rejected'] as const;
export type TimeEntryAdjustmentStatus = (typeof timeEntryAdjustmentStatusValues)[number];

export interface TimeEntryAdjustmentDto {
  id: string;
  companyId: string;
  employeeId: string;
  timeEntryId: string | null;
  requestedByUserId: string;
  requestedAt: string;
  status: TimeEntryAdjustmentStatus;
  reason: string;
  resolutionReason: string | null;
  originalClockInAt: string | null;
  originalClockOutAt: string | null;
  newClockInAt: string;
  newClockOutAt: string | null;
  approvedByUserId: string | null;
  approvedAt: string | null;
  rejectedByUserId: string | null;
  rejectedAt: string | null;
  affectsClosedPayPeriod: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface RequestTimeEntryAdjustmentRequest {
  companyId: string;
  timeEntryId?: string | null;
  newClockInAt: string;
  newClockOutAt: string | null;
  reason: string;
}

export interface RequestTimeEntryAdjustmentResponse {
  adjustment: TimeEntryAdjustmentDto;
}

export interface CreateTimeEntryAdjustmentRequest {
  companyId: string;
  employeeId: string;
  timeEntryId?: string | null;
  newClockInAt: string;
  newClockOutAt: string | null;
  reason: string;
}

export interface CreateTimeEntryAdjustmentResponse {
  adjustment: TimeEntryAdjustmentDto;
  timeEntry: TimeEntryDto;
}

export interface ListTimeEntryAdjustmentsRequest {
  companyId: string;
  status?: TimeEntryAdjustmentStatus;
  employeeId?: string;
}

export interface ListTimeEntryAdjustmentsResponse {
  items: TimeEntryAdjustmentDto[];
}

export interface ListMyTimeEntryAdjustmentsRequest {
  companyId: string;
}

export interface ListMyTimeEntryAdjustmentsResponse {
  items: TimeEntryAdjustmentDto[];
}

export interface ApproveTimeEntryAdjustmentRequest {
  companyId: string;
  adjustmentId: string;
  resolutionReason?: string | null;
}

export interface ApproveTimeEntryAdjustmentResponse {
  adjustment: TimeEntryAdjustmentDto;
  timeEntry: TimeEntryDto;
}

export interface RejectTimeEntryAdjustmentRequest {
  companyId: string;
  adjustmentId: string;
  resolutionReason: string;
}

export interface RejectTimeEntryAdjustmentResponse {
  adjustment: TimeEntryAdjustmentDto;
}
